// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1syEN","lds-dual-ring":"styles_lds-dual-ring__QhIB7"};